<template>
  <el-row :gutter="20">
    <el-col :span="20" :offset="2">
      <div class="setup">
        <el-card v-for="item in list_data" :key="item.index" shadow="hover">
          <el-row class="setup-content" :gutter="20">
            <el-col :span="6">
              <span
                @click="isSignature = true"
                v-if="item.type == 'signature' && userInfo.signatureText"
              >
                <img
                  class="signature-img"
                  src="~@/assets/images/setSignImg.png"
                  alt=""
                />
              </span>
              <div class="msg_icon">
                <img
                  :src="item.imgage"
                  :style="{
                    height: item.type == 'delInfo' ? '45px' : '60px',
                    width: item.type == 'signature' ? '60px' : '40px',
                    right: item.type == 'signature' ? '13px' : '20px',
                  }"
                  alt
                />
              </div>
            </el-col>
            <el-col class="setup-content-title" :span="12">
              <div class="msg_title">
                <span>{{ item.title }}</span>
                <span>{{ item.user_phone | ellipsis }}</span>
              </div>
              <div class="msg_detail">
                <span v-text="item.description"></span>
              </div>
            </el-col>
            <el-col :span="6">
              <el-button class="msg-button" @click="editHandle(item.type)">{{
                item.btnText
              }}</el-button>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="setup-content-color" shadow="hover">
          <el-row class="setup-content" :gutter="20">
            <el-col :span="24">
              <div class="msg_title">
                <span>安全服务提示</span>
              </div>
              <div class="msg_detail">
                <span
                  >确认您登录的是互联网远程问诊系统，注意防范进入钓鱼网站，不要轻信各种即时通讯工具发送的商品或支付链接，谨防网购诈骗</span
                >
              </div>
              <div class="msg_detail">
                <span
                  >建议您安装杀毒软件，并定期更新操作系统等软件补丁，确保帐号及交易安全</span
                >
              </div>
            </el-col>
          </el-row>
        </el-card>
        <!--登录密码修改-->
        <el-dialog
          :title="pwdChange"
          :visible.sync="isPwdChange"
          width="40%"
          :before-close="closeChangePhone"
          center
          :close-on-click-modal="false"
        >
          <el-form class="login_form" ref="form" :model="login_form">
            <!-- <el-form-item>
              <el-input
                v-model="changePhone.oldPhone"
                class="mobile"
                placeholder="手机号码"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item class="getPhoneCode">
              <el-input
                placeholder="请填写验证码"
                v-model="login_form.sms_code"
              ></el-input>
              <el-button
                type="primary"
                class="sendBtn"
                style="cursor: pointer"
                @click="sendCode('password')"
                :disabled="sendBtnDisable"
              >
                {{ code_tip }}</el-button
              >
            </el-form-item> -->

            <el-form-item>
              <el-input
                type="password"
                placeholder="请输入旧密码"
                v-model="login_form.old_pwd"
              >
                <i
                  slot="suffix"
                  title="show password"
                  style="cursor: pointer"
                  class="el-input__icon fa fa-eye"
                ></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                type="password"
                placeholder="请输入新密码"
                v-model="login_form.new_pwd"
              >
                <i
                  slot="suffix"
                  title="show password"
                  style="cursor: pointer"
                  class="el-input__icon fa fa-eye"
                ></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                type="password"
                placeholder="请再次输入新密码"
                v-model="login_form.repeat_password"
              >
                <i
                  slot="suffix"
                  title="show password"
                  style="cursor: pointer"
                  class="el-input__icon fa fa-eye"
                ></i>
              </el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button
              type="primary"
              class="submit custom-button-active"
              style="width: 100%"
              @click="changePwd()"
              >提交</el-button
            >
          </span>
        </el-dialog>

        <!--修改手机号码-->
        <el-dialog
          :title="mobileChange"
          :visible.sync="isMobileChange"
          width="40%"
          :before-close="closeChangePhone"
          center
          :close-on-click-modal="false"
        >
          <el-form ref="form" class="my_set_old_phone" :model="mobile_form">
            <el-form-item>
              <el-input
                type="text"
                v-model="changePhone.newPhone"
                class="mobile"
                placeholder="新手机号码"
              ></el-input>
            </el-form-item>
            <el-form-item class="getPhoneCode">
              <el-input
                placeholder="请填写验证码"
                v-model="changePhone.newCode"
              ></el-input>
              <el-button
                type="primary"
                class="sendBtn"
                @click="sendCode('newPhone')"
                :disabled="sendBtnDisable"
                >{{ code_tip }}</el-button
              >
            </el-form-item>
            <el-form-item class="sms_warpper">
              <el-button
                type="primary"
                style="width: 100%"
                class="submit custom-button-active"
                @click="changePhoneNumber()"
                >提交</el-button
              >
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 注销账户弹框 -->
        <el-dialog
          :title="deleteAccount"
          :visible.sync="isDeleteAccount"
          width="40%"
          :before-close="closeChangePhone"
          center
        >
          <el-form ref="form" class="my_set_old_phone" :model="mobile_form">
            <el-form-item>
              <el-input
                type="text"
                v-model="cause"
                class="mobile"
                placeholder="注销原因"
              ></el-input>
            </el-form-item>
            <el-form-item label="验证手机" prop="diagnose_result">
              <div class="captcha_phone">
                <p>{{ estarPhone(mobilePhone) }}</p>
              </div>
              <div class="captcha-item">
                <el-input
                  v-model="phoneCaptcha"
                  placeholder="请输入验证码"
                  type="text"
                ></el-input>
                <el-button
                  class="get-captcha"
                  size="mini"
                  @click="getPhoneCaptcha"
                  :disabled="sendCodeBtnDisable"
                >
                  {{ code_tip || "获取验证码" }}</el-button
                >
              </div>
            </el-form-item>
            <el-alert
              title="温馨提示:注销账户后，数据将不可恢复，请谨慎操作！"
              :closable="false"
              style="margin-bottom: 20px"
              type="error"
            ></el-alert>

            <el-form-item class="sms_warpper">
              <el-button
                type="danger"
                style="width: 100%"
                class="submit custom-button-active"
                @click="cancelAccount()"
                >确定注销</el-button
              >
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 签名图片弹框 -->
        <el-dialog
          title="签名图"
          :visible.sync="isSignature"
          width="50%"
          :before-close="closeChangePhone"
          center
        >
          <div class="demo-image__lazy">
            <el-image :src="ImageUrl + userInfo.signature" lazy></el-image>
          </div>
        </el-dialog>
      </div>
    </el-col>
    <!-- 注销协议弹框 -->
    <!-- <div v-if="showTermDialog">
      <termList
        v-on:agreeList="agreeListHide"
        v-on:e_Callback="ListHide"
        type="phr_delete"
      ></termList>
    </div> -->
  </el-row>
</template>

<script>
import util from "@/utils";
import cookie from "@/utils/cookie.js";
import {
  getCaptcha,
  updatePassword,
  changMobile,
  delInfo,
  // setSign,
  getDoctorInfo,
} from "@/api/index.js";
import { setSign } from "@/api/doctor.js";
// import termList from "@/components/common/termList";
import config from "@/config/config.js";
export default {
  // components: {
  //   termList,
  // },
  data() {
    return {
      ImageUrl: config.ImageUrl,
      type: "", //password  mobile
      country_code: util.country_code,
      country: util.country,
      mobile_form: {
        mobile: "",
        sms_code: "",
        email: "",
      },
      timer: null,
      sendBtnDisable: false,
      sendBtnDisableNew: false,
      code_tip: "获取验证码",
      login_form: {
        old_pwd: "",
        new_pwd: "",
        mobile: "",
        sms_code: "",
        repeat_password: "",
      },
      changePhone: {
        oldPhone: "",
        newPhone: "",
        oldCode: "",
        newCode: "",
        new_country_code: 86,
      },
      pwdChange: "登录密码修改",
      mobileChange: "手机号码修改",
      deleteAccount: "注销账户",
      isPwdChange: false,
      isMobileChange: false,
      isAccountDelete: false,
      isSignature: false,
      list_data: [
        {
          title: "药师电子签名",
          description:
            "该步骤需要经过CA机构认证，是一个资质审核和电子签章派发的过程",
          type: "signature",
          classType: "",
          icon: "fa fa-pencil mainTextColor",
          imgage: require("@/assets/images/signature.png"),
          btnText: "设置",
        },
        {
          title: "登录密码",
          description: "建议您定期更改密码，设置安全性高的密码可以使账号更安全",
          type: "password",
          classType: "",
          icon: "fa fa-pencil mainTextColor",
          imgage: require("@/assets/images/ulock.png"),
          btnText: "更换",
        },
        {
          title: "安全手机",
          description: "可以用于登录账号，重置密码或者其他安全验证",
          type: "mobile",
          classType: "",
          icon: "fa fa-mobile-phone fa-lg mainTextColor",
          imgage: require("@/assets/images/Phone6.png"),
          user_phone: util.getStore("user_mobile"),
          btnText: "更换",
        },
        {
          title: "注销账户",
          description:
            " 注销账户提示应该为“此操作必须谨慎，注销后其他相关数据无法恢复",
          type: "delInfo",
          classType: "",
          icon: "fa fa-mobile-phone fa-lg mainTextColor",
          imgage: require("@/assets/images/deleteAccount.png"),
          btnText: "注销",
        },
      ],
      check: {},
      user_phone: "",

      cause: "",
      isDeleteAccount: false,
      showTermDialog: false,
      userInfo: "",
      sendCodeBtnDisable: false,
      sickInfo: {
        caseContent_dictText: {},
      },
      phoneCaptcha: "",
      mobilePhone: "",
    };
  },
  created() {
    const that = this;
    that.code_tip = "获取验证码";
    that.changePhone.oldPhone = util.getStore("user_mobile");
    this.readyInfo();
  },
  filters: {
    ellipsis(value) {
      if (value == undefined) {
        return;
      }
      let len = value.length;
      return `${value.substring(0, 3)}****${value.substring(len - 4, len)}`;
    },
  },
  methods: {
    /*监听同意按钮*/
    agreeListHide: function () {
      // this.isAgree = true;
      // this.showTermDialog = false;
      this.isDeleteAccount = true;
    },
    //设置关闭协议弹框后不选中
    ListHide() {
      this.isAgree = false;
      // this.showTermDialog = false;
    },
    /**
     * 清除账户
     */
    async cancelAccount() {
      if (this.cause == "") {
        this.elementTips("error", "注销原因不能空");
        return;
      }
      if (this.phoneCaptcha == "") {
        this.$message({
          type: "error",
          message: "验证码不能为空",
        });
        return;
      }
      try {
        let params = {
          pharmacistId: util.getStore("user_id"),
          cause: this.cause,
          captcha: this.phoneCaptcha,
        };
        let res = await delInfo(params);
        if (res.code) {
          this.elementTips("success", "注销成功");
          this.isDeleteAccount = false;
          setTimeout(() => {
            this.$router.push({
              path: "/login",
            });
          }, 1000);
        } else {
          this.elementTips("error", res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    estarPhone(phoneNum) {
      if (phoneNum) {
        let str = String(phoneNum),
          strLen = str.slice(-7, -3);
        return str.replace(strLen, "****");
      } else {
        return "手机号未设置";
      }
    },
    //获取手机验证码登录
    async getPhoneCaptcha() {
      // this.mobilePhone=this.sickInfo.doctorMobile
      if (this.mobilePhone === "") {
        this.elementTips("error", "手机号码不能为空");
        return;
      }
      let isPhone =
        /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/.test(
          this.mobilePhone
        );
      if (!isPhone) {
        this.elementTips("error", "手机格式不正确");
        return;
      }
      const params = {
        mobile: this.mobilePhone,
        smsMode: "7",
      };
      let res = await getCaptcha(params);
      console.log("获取验证码", res);
      const { code, message } = res;

      if (code === 1) {
        this.countDown();
        this.elementTips("success", message);
        this.sendCodeBtnDisable = true;
      } else {
        this.sendCodeBtnDisable = false; //错误的情况下 解除禁止
        this.elementTips("warning", message);
      }
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    async changePwd() {
      try {
        if (this.login_form.old_pwd === "") {
          this.elementTips("error", "旧密码不能为空！");
          return;
        }
        if (this.login_form.new_pwd === "") {
          this.elementTips("error", "新密码不能为空！");
          return;
        }
        if (this.login_form.new_pwd !== this.login_form.repeat_password) {
          this.elementTips("error", "两次输入的密码不一致！");
          return;
        }
        let params = {
          oldPassword: this.login_form.old_pwd,
          newPassword: this.login_form.new_pwd,
        };
        let res = await updatePassword(params);
        if (res.code) {
          this.isPwdChange = false;
          this.elementTips("success", res.message);
          this.logout();
        } else {
          this.elementTips("error", res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    reset() {
      const that = this;
      that.changePhone.newPhone = "";
      that.changePhone.newCode = "";
      that.changePhone.oldCode = "";
      that.login_form.new_pwd = "";
      that.login_form.old_pwd = "";
      that.login_form.repeat_password = "";
      that.sendCodeBtnDisable = false;
      that.sendBtnDisable = false;
      that.sendBtnDisableNew = false;
      clearInterval(that.timer);
      that.code_tip = "获取验证码";
    },
    logout(){
      // 退出
      const that = this;
      util.removeStore("user_token");
      util.removeStore("username");
      util.removeStore("userInfo");
      util.removeStore("user_id");
      util.removeStore("userType");
      util.removeStore("user_mobile");
      cookie.delCookie("uid");
      cookie.delCookie("sdktoken");
      that.elementTips("success", "退出成功");
      setTimeout(function () {
        that.$router.push({
          path: "/login",
        });
        that.$store.dispatch("logout");
      }, 2000);
    },
    /*
     * 倒计时
     * */
    countDown() {
      const that = this;
      that.code_time = 60;
      that.sendBtnDisable = true;
      that.timer = setInterval(() => {
        that.code_tip = this.code_time + "s";
        that.code_time--;
        if (that.code_time <= 0) {
          clearInterval(that.timer);
          that.sendCodeBtnDisable = false;
          that.sendBtnDisable = false;
          that.sendBtnDisableNew = false;
          that.code_tip = "获取验证码";
          that.code_time = 60;
        }
      }, 1000);
    },

    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },

    /*
     *  注册绑定模式:0, 登录验证:1, 修改密码模式:2, 修改手机号:3；
     * */
    async sendCode() {
      try {
        const params = {
          // userType: util.sgetStore("userType"),
          // country_code: that.changePhone.new_country_code,
        };

        if (this.type === "password") {
          //修改密码
          params.mobile = this.changePhone.oldPhone;
          params.smsMode = "2";
        } else if (this.type === "mobile") {
          //修改手机号
          params.mobile = this.changePhone.newPhone;
          params.smsMode = "3";
        } else {
          //删除账号
        }
        if (params.mobile === "") {
          this.elementTips("error", "请填写手机号码");
          return;
        }
        this.sendCodeBtnDisable = true;
        let res = await getCaptcha(params);
        this.countDown();
        if (res.code) {
          this.elementTips("success", res.message);
        } else {
          this.sendCodeBtnDisable = false; //错误的情况下 解除禁止
          this.elementTips("error", res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    editHandle(type) {
      const that = this;
      that.type = type;
      if (type === "password") {
        that.isPwdChange = true;
        this.reset();
      } else if (type === "mobile") {
        that.isMobileChange = true;
      } else if (type === "delInfo") {
        // that.showTermDialog = true;
        this.isDeleteAccount = true;
      } else if (type === "signature") {
        this.setSignature();
      }
    },
    //设置签名
    async setSignature() {
      try {
        if (this.userInfo.departmentId == "") {
          this.elementTips("error", "请先设置医院、科室才能设置电子签名");
          return;
        }
        // let isidcard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(
        //   this.userInfo.identityCard
        // );

        // if (!isidcard) {
        //   this.elementTips("error", "用户身份证格式有误，请修改后设置电子签名");
        //   return;
        // }
        let data = {
          pharmacistId: util.getStore("user_id"),
        };
        let res = await setSign(data);
        if (res.code == 1) {
          this.readyInfo();
          this.$message.success(res.message);
        } else {
          this.elementTips("error", res.message);
        }
        this.formType = "sign";
        this.readyInfo();
      } catch (error) {
        console.log(error);
      }
    },

    closeChangePhone() {
      const that = this;
      that.isMobileChange = false;
      that.isPwdChange = false;
      that.isAccountDelete = false;
      this.isDeleteAccount = false;
      this.isSignature = false;
      that.reset();
    },

    /*
     * 确认更换手机号码
     * */
    async changePhoneNumber() {
      try {
        if (this.changePhone.newPhone == "") {
          this.elementTips("error", "请输入新的手机号码");
          return;
        }
        if (this.changePhone.newCode == "") {
          this.elementTips("error", "请填写验证码");
          return;
        }
        const params = {
          id: util.getStore("user_id"),
          mobile: this.changePhone.newPhone,
          captcha: this.changePhone.newCode,
        };
        let res = await changMobile(params);
        this.sendCodeBtnDisable = false; //错误的情况下 解除禁止
        this.isMobileChange = false;
        if (res.code) {
          this.elementTips("success", res.message);
          this.readyInfo();
          this.reset();
        } else {
          this.elementTips("error", res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // /*获取用户信息*/
    async readyInfo() {
      try {
        let params = {
          id: util.getStore("user_id"),
        };
        let res = await getDoctorInfo(params);
        if (res.code) {
          this.mobilePhone = res.data.pharmacist.mobile;
          this.userInfo = res.data.pharmacist;
          util.setStore("user_mobile", res.data.pharmacist.mobile);
          this.list_data[2].user_phone = res.data.pharmacist.mobile;
          if (!this.formType && this.formType !== "sign") {
            //签名拒绝
            if (this.userInfo.medicalNetStatus !== "200") {
              this.$notify({
                title: "电子签名未设置，请设置签名",
                dangerouslyUseHTMLString: true,
                message: res.data.pharmacist.medicalNetNote,
                type: "warning",
                duration: 8000,
              });
              return false;
            }
            if (this.userInfo.medicalNetStatus !== "200") {
              this.$notify({
                title: "电子签名失败,请同步签名状态",
                dangerouslyUseHTMLString: true,
                message: res.data.pharmacist.medicalNetNote,
                type: "warning",
                duration: 8000,
              });
              return false;
            }
            this.formType = "";
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss">
.setup-title {
  height: 150px;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
}

.setup-content {
  height: 100px;
}

.setup .msg_detail {
  margin: 10px 0;
  font-size: 14px;
  color: #999999;
}
.setup .setup-content-color .msg_detail:before {
  content: "•";
  color: #999999;
  margin-right: 4px;
}

.setup .el-col-6 {
  height: 100px;
}

.setup .msg_icon {
  width: 100%;
  height: 50%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.setup .msg-button {
  width: 50%;
  height: 50%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  background-image: url("../../../assets/images/rectangle7.png");
  background-size: 100% 100%;
}
.setup .setup-content-color {
  background-color: #f2f2f2;
}

.setup .create_time {
  font-size: 11px;
  color: #999;
}

.setup .msg_icon img {
  position: absolute;
  width: 40px;
  height: 60px;
  right: 20px;
}
.deleteAccount {
  height: 40px;
}

.setup .el-card {
  margin-top: 50px;
}

.setup-content-title {
  width: 50%;
  height: 50%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.setup .getPhoneCode {
  text-align: left;
}
.setup .getPhoneCode .el-form-item__content .el-input {
  width: 65%;
  float: left;
}
.setup .sendBtn {
  width: 25%;
  text-align: center;
  font-size: 12px;
  display: inline-block;
  float: right;
}
.signature-img {
  width: 30px;
  height: 30px;
  position: absolute;
  right: 20px;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
